module.exports = __webpack_public_path__ + "static/media/pct.7df89a76.woff";